import { render, staticRenderFns } from "./ReviewPostDoc.vue?vue&type=template&id=69360dbc&scoped=true&"
import script from "./ReviewPostDoc.vue?vue&type=script&lang=js&"
export * from "./ReviewPostDoc.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPostDoc.vue?vue&type=style&index=0&id=69360dbc&prod&lang=css&"
import style1 from "./ReviewPostDoc.vue?vue&type=style&index=1&id=69360dbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69360dbc",
  null
  
)

export default component.exports